<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Property Description:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-6">
          <app-block-text
            [type]="'link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'PropertyDescImageDesktop')"
            [blockData]="block.variables?.PropertyDescImageDesktop ?? ''"
            [placeholder]="imageDesktopPlaceholder"
            variable="PropertyDescImageDesktop"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'PropertyDescImageMobile')"
            [blockData]="block.variables?.PropertyDescImageMobile ?? ''"
            [placeholder]="imageMobilePlaceholder"
            variable="PropertyDescImageMobile"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'PropertyDescImageHref')"
            [blockData]="block.variables?.PropertyDescImageHref ?? ''"
            [placeholder]="imageHrefPlaceholder"
            variable="PropertyDescImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'PropertyDescImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.PropertyDescImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'PropertyDescImageAlt')"
            [blockData]="block.variables?.PropertyDescImageAlt ?? ''"
            [placeholder]="imageAltPlaceholder"
            variable="PropertyDescImageAlt"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'PropertyDescPropertyName')"
            [blockData]="block.variables?.PropertyDescPropertyName ?? ''"
            [placeholder]="namePlaceholder"
            variable="PropertyDescPropertyName"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event, 'PropertyDescription')"
            [blockData]="block.variables?.PropertyDescription ?? ''"
            [placeholder]="descriptionPlaceholder"
            variable="PropertyDescription"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'PropertyDescCtaLink')"
            [blockData]="block.variables?.PropertyDescCtaLink ?? ''"
            [placeholder]="ctaLinkPlaceholder"
            variable="PropertyDescCtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'PropertyDescCtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.PropertyDescCtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="30"
            (handleOnChange)="onChange($event, 'PropertyDescCtaText')"
            [blockData]="block.variables?.PropertyDescCtaText ?? ''"
            [placeholder]="ctaTextPlaceholder"
            variable="PropertyDescCtaText"
          ></app-block-text>
        </div>
      </div>
    </div>

    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-left">
          <div class="col-12" *ngIf="block.variables?.PropertyDescImageDesktop">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.PropertyDescImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.PropertyDescImageDesktop)"
                class="img-fluid full-width-img"
                [alt]="$safeNavigationMigration(block.variables?.PropertyDescImageAlt)"
            /></a>
          </div>
        </div>
        <div class="row text-left mt-2">
          <div class="col-12">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.PropertyDescPropertyName)"></p>
          </div>
          <div class="col-12">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.PropertyDescription)"></p>
          </div>
          <div class="col-12 mt-2" *ngIf="block.variables?.PropertyDescCtaLink">
            <a
              class="btn btn-primary"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.PropertyDescCtaLink))"
              target="_blank"
              [innerHTML]="$safeNavigationMigration(block.variables?.PropertyDescCtaText)"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
